import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {from, Observable} from 'rxjs';
import {Logger} from '../utils/logger';
// import {Libraries, Loader} from '@googlemaps/js-api-loader';
import {environment} from '../../../environments/environment';
import {GoogleMapsLoader} from "../utils/google-map-api-loader";

@Injectable({
  providedIn: 'root'
})
export class MapLoaderGuardService implements CanActivate {
  private isApiLoaded = false;

  constructor() {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    Logger.log('canActivate MapLoaderGuardService ', next)
    return from(this.loadApi());
  }

  loadApi() {
    return new Promise<boolean>((resolve) => {
      if (!this.isApiLoaded) {
        Logger.log('Loading Google Maps...');
        const gLoader = new GoogleMapsLoader({
          apiKey: environment.googleMapApiKey,
          version: 'beta',
          // maps3d is deliberately NOT listed here. It is fetched on demand by
          // Map3dComponent through importLibrary('maps3d'), which is how the 3D
          // map is meant to be loaded; naming it in this legacy libraries
          // parameter as well leaves the element mounted but inert — it shows
          // its spinner and never requests a single tile.
          libraries: ['marker', 'places', 'geometry', 'visualization']
        });
        return gLoader.load().then(() => {
          Logger.log('Google Maps LOADED');
          this.isApiLoaded = true;
          resolve(true);
        }).catch(err => {
          resolve(false);
          Logger.error('Failed to load Google Maps');
        })
      } else {
        Logger.log('Google Maps already loaded');
        resolve(true);
      }
    });
  }
}
